var lowercase = function lowercase(value) {
  return String(value).toLowerCase();
};
var trim = function trim(value) {
  return String(value).trim();
};
var uppercase = function uppercase(value) {
  return String(value).toUpperCase();
};
export default {
  lowercase: lowercase,
  trim: trim,
  uppercase: uppercase
};